import React from 'react';
import { ArrowLeft, Heart, Users, Target, Lightbulb } from 'lucide-react';
import { useI18n } from '../i18n';

export default function About({ onBack }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 sm:px-6">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={20} />
            <span className="font-medium">{t('common.back')}</span>
          </button>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 sm:py-12">
        <div className="bg-white rounded-xl border border-gray-200 p-6 sm:p-10">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="Dojo Mojo" className="h-16 sm:h-20 w-auto mx-auto mb-4" />
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              {t('about.title')}
            </h1>
            <p className="text-lg text-gray-600">
              {t('about.subtitle')}
            </p>
          </div>

          <div className="prose prose-gray max-w-none space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <Heart className="text-peach-400" size={28} />
                {t('about.storyTitle')}
              </h2>
              <p className="leading-relaxed">
                {t('about.storyBody')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <Target className="text-lavender-400" size={28} />
                {t('about.missionTitle')}
              </h2>
              <p className="leading-relaxed">
                {t('about.missionBody')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <Lightbulb className="text-peach-400" size={28} />
                {t('about.visionTitle')}
              </h2>
              <p className="leading-relaxed">
                {t('about.visionBody')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                <Users className="text-lavender-400" size={28} />
                {t('about.supportTitle')}
              </h2>
              <p className="leading-relaxed">
                {t('about.supportBody')}
              </p>
            </section>

            <section className="bg-lavender-50 rounded-xl p-6 mt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('about.contactTitle')}
              </h2>
              <p className="leading-relaxed mb-4">
                {t('about.contactBody')}
              </p>
              <div className="space-y-2">
                <p><strong>{t('about.contactEmailLabel')}</strong> <a href="mailto:contato@dojomojo.com.br" className="text-lavender-600 hover:text-lavender-700 underline">contato@dojomojo.com.br</a></p>
                <p><strong>{t('about.companyName')}</strong></p>
                <p>{t('about.companyCnpj')}</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
